import React, { PureComponent } from 'react';
import { FormattedMessage } from 'react-intl';
import defaultMsg from '../../../../../../translations/lang/en-US.json';

const PICKUP_ORDER_TYPE = 'pickup';
const DELIVERY_ORDER_TYPE = 'delivery';
const DINE_IN_ORDER_TYPE = 'dine-in';

class DiningAddress extends PureComponent {
  render() {
    const { orderType='', customerAddress='' } = this.props;

    let orderTypeText = '';
    switch (orderType.toLowerCase()) {
      case PICKUP_ORDER_TYPE:
        orderTypeText = defaultMsg.orderedFrom;
        break;
      case DELIVERY_ORDER_TYPE:
        orderTypeText = defaultMsg.deliveredTo;
        break;
      case DINE_IN_ORDER_TYPE:
        orderTypeText = defaultMsg.dineInAt;
        break;
    }
    return (
      <div>
        <small>
          <div className="olo-client-theme-color">
            <FormattedMessage id="orderedFrom" defaultMessage={orderTypeText} />{' '}:
          </div>
          <div className="break-word">
            {customerAddress}
          </div>
        </small>
      </div>
    );
  }
}

export default DiningAddress;



// WEBPACK FOOTER //
// ./src/views/CustomerOrderHistory/components/OrderHistoryPanel/OrderHistoryBody/OrderDetails/DiningAddress.jsx